module.exports = __webpack_public_path__ + "static/media/new-automa-logo.28615f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/new-automa-logo.png
// module id = 176
// module chunks = 0